import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { NameAndAddressService } from 'src/app/services/name-and-address/name-and-address.service';
import { NameAndAddress } from 'src/app/shared/common-components/common-structure';

@Component({
    selector: 'app-billoflading-addresses',
    templateUrl: './billoflading-addresses.component.html',
    styleUrls: ['./billoflading-addresses.component.css'],
    standalone: false
})
export class BillofladingAddressesComponent implements OnInit {
  public modalCalledFrom: any; // use this field to determine from where the modal window is called.

  shipmentInfoId: any;
  nameAndAddressesData: NameAndAddress[];
  originData: NameAndAddress;
  shipperData: NameAndAddress;
  billToData: NameAndAddress;
  destinationData: NameAndAddress;
  consigneeData: NameAndAddress;
  issuingOfficer: NameAndAddress;

  constructor(
    private bsModalRef: BsModalRef,
    private nameAndAddressService: NameAndAddressService
  ) { }

  ngOnInit() {
    this.nameAndAddressService.getShipmentAddresses(this.shipmentInfoId).subscribe(addresses => {
      this.nameAndAddressesData = addresses;
      for (const address of addresses) {
        if (address.recordType === 'Origin') {
          this.originData = address;
        } else if (address.recordType === 'Destination') {
          this.destinationData = address;
        } else if (address.recordType === 'Shipper') {
          this.shipperData = address;
        } else if (address.recordType === 'Bill To') {
          this.billToData = address;
        } else if (address.recordType === 'Consignee') {
          this.consigneeData = address;
        } else if (address.recordType === 'Issue Office') {
          this.issuingOfficer = address;
        }
      }
    });
  }

  closeModal() {
    this.bsModalRef.hide();
  }
}
